import React from "react";
import { Box, Typography, Divider, Button } from "@mui/material";
import ColorPicker from "./ColorPicker";

const ColorThemeSelector = ({
  colorFields,
  values,
  setValues,
  onResetCustomizations,
}) => {
  const hasAnyColor = colorFields.some((f) => values[f.key]);

  const handleChange = (key) => (hex) => {
    setValues((prev) => ({ ...prev, [key]: hex }));
  };

  return (
    <Box
      sx={{
        border: "1px solid #eee",
        borderRadius: 2,
        p: 3,
        mt: 4,
        backgroundColor: "#fafafa",
      }}>
      <Typography variant="h6" gutterBottom>
        Cake Color Theme
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Color selection is a guide only — we will do our best to match your
        vision, but exact shades cannot be guaranteed. If no colors are chosen,
        default theme from the image will be used.
      </Typography>

      <Divider sx={{ mb: 2 }} />

      {colorFields.map((field, index) => (
        <Box
          key={field.key}
          sx={{ mb: index < colorFields.length - 1 ? 3 : 0 }}>
          <ColorPicker
            label={field.label}
            selectedHex={values[field.key] || ""}
            onChange={handleChange(field.key)}
          />
        </Box>
      ))}

      {hasAnyColor && (
        <Button
          onClick={onResetCustomizations}
          size="small"
          color="inherit"
          sx={{ mt: 3, textTransform: "none" }}>
          Reset Colors
        </Button>
      )}
    </Box>
  );
};

export default ColorThemeSelector;
